package music.jammers.client.shared.event.track.domain.usecase

import music.jammers.client.shared.event.domain.model.ValidationError
import music.jammers.client.shared.event.track.domain.validator.EventTrackFieldValidator
import music.jammers.client.shared.event.track.presentation.model.UpdateInstrument

class ValidateEventTrackUseCase(
    private val eventTrackFieldValidator: EventTrackFieldValidator,
) {

    operator fun invoke(
        artistName: String,
        trackName: String,
        instruments: List<UpdateInstrument>,
    ): List<ValidationError> {
        val errors = mutableListOf<ValidationError?>()

        errors.add(eventTrackFieldValidator.validate(ARTIST_NAME, artistName))
        errors.add(eventTrackFieldValidator.validate(TRACK_NAME, trackName))
        errors.add(eventTrackFieldValidator.validate(instruments))

        return errors.filterNotNull()
    }

    companion object Fields {

        const val ARTIST_NAME = "artistName"
        const val TRACK_NAME = "trackName"
        const val SELECTED_INSTRUMENTS = "selectedInstruments"
    }
}